/** CEO／portalToken 內部運維入口閘（Console／Portal）；C 端會員走 /leo/chat。 */
const STORAGE_PORTAL = 'leo_portal_token'
const STORAGE_CEO = 'leo_ceo_bearer'

export function hasLeoPortalGate (query) {
  const q = query || {}
  if (String(q.ceoBearer || '').trim()) return true
  if (String(q.portalToken || q.token || '').trim()) return true
  if (typeof sessionStorage !== 'undefined') {
    if (String(sessionStorage.getItem(STORAGE_CEO) || '').trim()) return true
    if (String(sessionStorage.getItem(STORAGE_PORTAL) || '').trim()) return true
  }
  return false
}



// WEBPACK FOOTER //
// ./src/utils/leoPortalGate.js